import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../config/Translate";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import SubTitleLight from "../../../components/elements/SubTitleLight";
import SingleOrderItemSimple from "../components/SingleOrderItemSimple";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography/Typography";
import FiberManualRecordRoundedIcon from "@material-ui/icons/FiberManualRecordRounded";
import {connect} from "trim-redux";
import GetConfirmationText from "../../../components/elements/GetConfirmationText";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import axios from "axios";
import {defaultVariabls} from "../../../../config";

class ViewOrder extends React.Component {
    classes = this.props.classes;
    state = {
        action_clicked:false,
    }
    async handlePayOrder(){
        let {action_clicked} = this.state;
        if(!action_clicked){
            this.setState({
                action_clicked:true,
            })
            let {item} = this.props;
            let data = new FormData();
            data.append('id', item.id);

            let loginToken = localStorage.getItem('ACT');
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.post(`${defaultVariabls.url}/factor/user_received_post`, data, config)
                .then(response => {
                    this.props.reload();

                })
                .catch(error => {
                    console.log(error.response)
                    this.setState({
                        loading:false,
                        SubmitLoading: false,
                    });
                });

        }

    }
    async handleShipmentFailure(){
        let {action_clicked} = this.state;
        if(!action_clicked){
            this.setState({
                action_clicked:true,
            })
            let {item} = this.props;
            let data = new FormData();
            data.append('id', item.id);

            let loginToken = localStorage.getItem('ACT');
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.post(`${defaultVariabls.url}/factor/user_shipment_failure`, data, config)
                .then(response => {
                    this.props.enqueueSnackbar(Translate.shipmentFailureNotif, {
                        variant: 'info',
                    });
                    this.props.reload();

                })
                .catch(error => {
                    console.log(error.response)
                    this.setState({
                        loading:false,
                        SubmitLoading: false,
                    });
                });

        }

    }
    render(){
        let {index,item,factor} = this.props;
        return (
            <Grid container spacing={2} style={{marginTop:15,marginBottom:15}}>
                <Grid item xs={12}  >
                    <div className="order-items-holder" key={index} style={{backgroundColor:"#fafafa",borderRadius:6,padding:"20px 10px 10px",marginBottom:10}}>
                        <Typography>{index+1}</Typography>
                        <Typography>{Translate.shopName} <span className="result">{item.shop.name}</span></Typography>

                        {
                            factor.status !== 'not_payed' &&
                            <>
                                <Typography>
                                    <FiberManualRecordRoundedIcon fontSize="small"/>
                                </Typography>
                                <Typography>
                                    {Translate.status} <span className={"order_badge "+item.status} >{Translate[item.status]}</span>
                                </Typography>
                            </>
                        }
                        {
                            !!item.shipping_code &&
                            <>
                                <Typography>
                                    <FiberManualRecordRoundedIcon fontSize="small"/>
                                </Typography>
                                <Typography>{Translate.shipping_code} <span className="result">{item.shipping_code}</span></Typography>
                                {
                                    item.status === "done" &&
                                    <Typography style={{display:"flex", alignItems:"center"}}>
                                        <GetConfirmationText
                                            tooltip={Translate.submitReceivngBox}
                                            className={this.classes.link}
                                            style={{
                                                cursor:"pointer",
                                                color: this.props.primary_color,
                                                marginBottom:0,
                                                border: "1px solid rgb(89, 165, 216)",
                                                padding: "5px 8px",
                                                borderRadius: 4
                                            }}
                                            handleAction={() => this.handlePayOrder()}
                                            question={Translate.submitReceivngBoxQ}
                                            yes_btn={Translate.submitReceivngBoxShort}
                                            icon={<CheckBoxIcon/>}
                                            size="small"
                                            color={this.props.primary_color}
                                        >
                                            {Translate.submitReceivngBox}
                                        </GetConfirmationText>
                                        {
                                            (item.shipment_failure_active === 1 && item.auto_pay === 1) &&
                                            <GetConfirmationText
                                                tooltip={Translate.submitReceivngBox}
                                                className={this.classes.link}
                                                style={{
                                                    margin:" 0 10px"
                                                }}
                                                handleAction={() => this.handleShipmentFailure()}
                                                question={Translate.ShipmentFailureBoxQ}
                                                yes_btn={Translate.shipmentFailureBoxShort}
                                                icon={<CheckBoxIcon/>}
                                                size="small"
                                                variant="contained"
                                                btn_color="secondary"
                                            >
                                                {Translate.submitShipmentFailure}
                                            </GetConfirmationText>
                                        }
                                    </Typography>
                                }
                            </>
                        }
                    </div>
                    <SubTitleLight align="left">
                        {Translate.products}
                    </SubTitleLight>
                    {
                        item.order_items.map((item,index) => (
                            <SingleOrderItemSimple factor_status={factor.status} key={index} item={item} view/>
                        ))
                    }
                </Grid>

            </Grid>


        );
    }
}
const mstp = state => ({
    user: state.user,
    secondary_color: state.secondary_color,
    primary_color: state.primary_color,
});
export default withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(ViewOrder))));